import React from 'react';
import { Redirect, BrowserRouter as Router, useLocation } from 'react-router-dom';
import { ApolloProvider } from './ApolloProvider';
import { AppDashboard } from './AppDashboard';
import { AppEmbed, AppPublicEmbed } from './Embed/AppEmbed';
import { useRefreshTokenBeforeExpiration } from './Hooks';
import isProduction from './isProduction';
import { addMarkerIO } from './markerIO';
import { isLoggedIn } from './utils';
import { heapInitialize } from './utils/heap';

if (!isProduction) {
  void addMarkerIO();
}

heapInitialize();

const useEmbedApp = process.env.REACT_APP_EMBED_APP === 'true';
const usePublicEmbedApp = process.env.REACT_APP_PUBLIC_EMBED_APP === 'true';

const renderApp = () => {
  if (useEmbedApp) {
    return (
      <AuthCheck>
        <AppEmbed />
      </AuthCheck>
    );
  }
  if (usePublicEmbedApp) {
    return <AppPublicEmbed />;
  }
  return <AppDashboard />;
};

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <ApolloProvider>
        <Router>{renderApp()}</Router>
      </ApolloProvider>
    </React.StrictMode>
  );
};

const AuthCheck = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const isOnLoginPage = location.pathname.startsWith('/login');

  useRefreshTokenBeforeExpiration(1000 * 60 * 6);

  if (!isOnLoginPage && !isLoggedIn()) {
    return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
  }

  return children ?? <></>;
};

export default App;
